import React from 'react'
import { Outlet } from 'react-router-dom'
import cx from 'classnames'

import styles from './Main.module.css'

import Sidebar from '../Sidebar'
import Topbar from '../Topbar'

import Toast from './Toast'

const Main = () => {
  return (
    <section className={cx('modern', styles.Root)}>
      <aside className={styles.SidebarContainer} aria-label='Sidebar'>
        <Sidebar />
      </aside>
      <section className={styles.MainContainer}>
        <Topbar />
        <main className={styles.Content}>
          <Outlet />
        </main>
      </section>
      <Toast />
    </section>
  )
}

export default Main
